import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/home/HomeView.vue'
import CompanyView from '@/views/company/CompanyView.vue'
import SolutionView from '@/views/solution/SolutionView.vue'
import ServerView from '@/views/service/ServerView.vue'
import PorductView from '@/views/product/ProductView.vue'
import ProjectsView from '@/views/projects/ProjectsView.vue'
import NewsView from '@/views/news/NewsView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    name: 'home',
    path: '/',
    component: HomeView,
    meta: {
      keepAlive: true
    }
  },
  {
    name: 'solution',
    path: '/solution',
    component: SolutionView,
    meta: {
      keepAlive: true
    }
  },
  {
    name: 'company',
    path: '/company',
    component: CompanyView,
    meta: {
      keepAlive: true
    }
  },
  {
    name: 'service',
    path: '/service',
    component: ServerView,
    meta: {
      keepAlive: true
    }
  },
  {
    name: 'product',
    path: '/product',
    component: PorductView,
    meta: {
      keepAlive: true
    }
  },
  {
    name: 'projects',
    path: '/projects',
    component: ProjectsView,
    meta: {
      keepAlive: true
    }
  },
  {
    name: 'news',
    path: '/news',
    redirect: '/news/selection'
  },
  {
    name: 'selectionNotice',
    path: '/news/selection',
    component: NewsView,
    meta: {
      keepAlive: true
    }
  },
  {
    name: 'awardNotice',
    path: '/news/award',
    component: NewsView,
    meta: {
      keepAlive: true
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
